
import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Box, Snackbar } from "@mui/material";
import axios from "axios";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

function SetMargin() {
  const [margin, setMargin] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [SnackbarMsg, setSnackbarMsg] = useState("");
  const [marginModalOpen, setMarginModalOpen] = useState(false);

  // Handle input change
  const handleInputChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) { // Allow only positive numbers and decimals
      setMargin(value);
    }
  };

  // Handle API call on Save
  const handleSaveMargin = async () => {
    try {
      const token = localStorage.getItem("sessionToken");

      if (!margin.trim()) {
        setSnackbarMsg("Margin is required");
        setOpenSnackbar(true);
        return;
      }

      const response = await axios.post(
        `https://api.exampladmedia.com/api/publications/setMargin?margin=${margin}`,
        null,
        {
          headers: {
            Authorization: token,
          },
        }
      );

      if (response.status === 200) {
        console.log(response);
        setSnackbarMsg("Margin updated successfully!");
        setOpenSnackbar(true); // Show success snackbar

        setMarginModalOpen(false);
        setMargin(""); // Clear input after success
      }
    } catch (error) {
      console.error("Error calling the API:", error);
      setSnackbarMsg("Error updating margin.");
      setOpenSnackbar(true);
    }
  };

  return (
    <DashboardLayout>
      <MDBox
        pt={3}
        pb={3}
        height="100vh"
        display="flex"
        justifyContent="center"
        alignItems="center"
        sx={{ overflow: "hidden" }}
      >
        <Grid container justifyContent="center" alignItems="center">
          <Grid item xs={12} sm={8} md={6}>
            <Card sx={{ display: "flex", flexDirection: "column", alignItems: "center", p: 3 }}>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
              >
                <h2 style={{ color: "white", margin: 0 }}>Set Margin Price</h2>
              </MDBox>
              <MDBox
                py={4}
                px={3}
                display="flex"
                flexDirection="column"
                justifyContent="center"
                alignItems="center"
                width="100%"
              >
                <Grid container spacing={2} direction="column" alignItems="center">
                  <Grid item xs={12} style={{ width: "100%", paddingLeft: 90 }}>
                    <TextField
                      fullWidth
                      label="Margin"
                      variant="outlined"
                      name="margin"
                      value={margin}
                      onChange={handleInputChange}
                      type="number"
                      inputMode="decimal"
                      onKeyDown={(e) => {
                        if (["e", "E", "+", "-"].includes(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      sx={{ maxWidth: 400 }}
                    />
                  </Grid>
                </Grid>
                <Box display="flex" justifyContent="center" mt={3} gap={2}>
                  <Button variant="contained" color="primary" style={{ color: "white" }} onClick={handleSaveMargin}>
                    Save
                  </Button>
                </Box>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Snackbar open={openSnackbar} message={SnackbarMsg} autoHideDuration={2000} onClose={() => setOpenSnackbar(false)}   anchorOrigin={{ vertical: "top", horizontal: "right" }}
  sx={{ zIndex: 1 }}/>
    </DashboardLayout>
  );
}

export default SetMargin;
